import React, { useState, useEffect } from "react";
import { getColor, createColor, editColor, publishColors } from "../../api/api";
import { NecStore } from "../../store/necStore";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Loader from "../loader/loader";
import "../colors/colors.css";
import ToolTip from "../tooltip/tooltip";
import { UserStore } from "../../store/userStore";

const Color = (props) => {
  const initState = {
    primaryBackgroundColor: "",
    secondaryBackgroundColor: "",
    primaryTextColor: "",
    secondaryTextColor: "",
    primaryHighlightColor: "",
    secondaryHighlightColor: "",
    menuBackgroundColor: "",
    elementBackgroundColor: "",
    elementForegroundColor: "",
    buttonBackgroundColor: "",
    buttonForegroundColor: "",
    menuForegroundColor: "",
    textShadow: true,
    dark: false,
  };
  const [colorSchema, setColor] = useState(initState);
  const [colorCount, setColorCount] = useState("");
  const [colorStatus, setColorStatus] = useState(0);
  const [lan] = useState("ltr");
  const [loading, setLoading] = useState(false);
  const [hold] = useState(false);
  const [name, setName] = useState("");
  const role = NecStore.useState((s) => s.setting);
  const user = UserStore.useState((s) => s.user);
  var RegExp = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i;
  const handleChange = (evt) => {
    const value = evt.target.value;
    setName(evt.target.name);
    setColor({
      ...colorSchema,
      [evt.target.name]: value,
    });
  };

  useEffect(() => {
    const colorDetail = async () => {
      setLoading(true);
      /* eslint-disable no-unused-vars */
      const result = await getColor().then(
        (result) => {
          setColor((prevState) => ({
            ...prevState,
            primaryBackgroundColor: result.data.primaryBackgroundColor,
            secondaryBackgroundColor: result.data.secondaryBackgroundColor,
            primaryTextColor: result.data.primaryTextColor,
            secondaryTextColor: result.data.secondaryTextColor,
            primaryHighlightColor: result.data.primaryHighlightColor,
            secondaryHighlightColor: result.data.secondaryHighlightColor,
            menuBackgroundColor: result.data.menuBackgroundColor,
            elementBackgroundColor:
              result.data.elementBackgroundColor === "true"
                ? ""
                : result.data.elementBackgroundColor,
            elementForegroundColor: result.data.elementForegroundColor,
            buttonBackgroundColor: result.data.buttonBackgroundColor,
            buttonForegroundColor: result.data.buttonForegroundColor,
            menuForegroundColor: result.data.menuForegroundColor,
            textShadow: result.data.textShadow,
            dark: result.data.dark,
          }));

          setLoading(false);
        },
        (error) => {
          const obj = {
            status: error.response.data.error.status,
            message: error.response.data.error.message,
          };
          setColorCount(obj.message);
          setColorStatus(obj.status);
          setLoading(false);
        }
      );
      /* eslint-disable no-unused-vars */
    };
    colorDetail();
  }, [lan]);

  const updateVisiblity = (event) => {
    // setDisable(false);
    setColor({
      ...colorSchema,
      [event.target.name]: event.target.checked,
    });
  };

  const colorSave = async (event) => {
    // setDisable(true);
    setLoading(true);
    event.preventDefault();

    if (
      !!colorSchema.primaryBackgroundColor &&
      !!colorSchema.secondaryBackgroundColor &&
      !!colorSchema.primaryTextColor &&
      !!colorSchema.secondaryTextColor &&
      !!colorSchema.primaryHighlightColor &&
      !!colorSchema.secondaryHighlightColor
    ) {
      if (colorStatus === 404 || colorCount === "No Color Schema Exists") {
        /* eslint-disable no-unused-vars */
        const result = await createColor(colorSchema).then(
          (result) => {
            toastr.success("Successfully Saved", "Success");
            setLoading(false);
          },
          (error) => {
            toastr.error(error.response.data.error.message, "Error");
            setLoading(false);
          }
        );
        /* eslint-disable no-unused-vars */
      } else {
        const result = await editColor(colorSchema).then(
          (result) => {
            toastr.success("Successfully Saved", "Success");
            setLoading(false);
          },
          (error) => {
            toastr.error(error.response.data.error.message, "Error");
            setLoading(false);
          }
        );
      }
    } else {
      toastr.error("Please fill all fields with * notation", "Required");
    }
  };

  const publishColor = async (event) => {
    // setDisable(true);
    if (role.production === true) {
      setLoading(true);
      event.preventDefault();

      /* eslint-disable no-unused-vars */
      const result = await publishColors().then(
        (result) => {
          toastr.success("Successfully Saved", "Success");
          setLoading(false);
        },
        (error) => {
          toastr.error(error.response.data.error.message, "Error");
          setLoading(false);
        }
      );
    } else {
      toastr.error("Preview Environment is off", "Error");
    }
    /* eslint-disable no-unused-vars */
  };

  if (loading) {
    return (
      <div className="content">
        <Loader />
      </div>
    );
  } else {
    return (
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h3
                    className={
                      lan === "rtl"
                        ? "card-title float-right"
                        : "card-title float-left"
                    }
                  >
                    Color Schema
                  </h3>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <form onSubmit={colorSave}>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip
                                info={"Background Color used in main layout"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Primary Background Color *&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={"Background Color used in main layout"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <input
                            type="text"
                            name="primaryBackgroundColor"
                            className="form-control inside-form"
                            dir={lan === "rtl" && hold === true ? "rtl" : "ltr"}
                            style={
                              lan === "rtl"
                                ? { textAlign: "end" }
                                : { textAlign: "initial" }
                            }
                            placeholder="Primary Background Color ..."
                            defaultValue={colorSchema.primaryBackgroundColor}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                          {RegExp.test(colorSchema.primaryBackgroundColor) ===
                            false && <div className="error"></div>}
                          {RegExp.test(colorSchema.primaryBackgroundColor) ===
                            true && <div className="correct"></div>}
                        </div>
                      </div>
                      <div className="col-sm-6">
                        {/* text input */}
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip
                                info={
                                  "Background Color used in secondary layout"
                                }
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Secondary Background Color *&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={
                                  "Background Color used in secondary layout"
                                }
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <input
                            type="text"
                            name="secondaryBackgroundColor"
                            className="form-control inside-form"
                            dir={lan === "rtl" && hold === true ? "rtl" : "ltr"}
                            style={
                              lan === "rtl"
                                ? { textAlign: "end" }
                                : { textAlign: "initial" }
                            }
                            placeholder="Secondary Background Color.."
                            defaultValue={colorSchema.secondaryBackgroundColor}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                          {RegExp.test(colorSchema.secondaryBackgroundColor) ===
                            false && <div className="error"></div>}
                          {RegExp.test(colorSchema.secondaryBackgroundColor) ===
                            true && <div className="correct"></div>}
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip
                                info={"Color used for headings"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Primary Text Color *&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={"Color used for headings"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <input
                            type="text"
                            name="primaryTextColor"
                            className="form-control inside-form"
                            dir={lan === "rtl" && hold === true ? "rtl" : "ltr"}
                            style={
                              lan === "rtl"
                                ? { textAlign: "end" }
                                : { textAlign: "initial" }
                            }
                            placeholder="Primary Text Color.."
                            defaultValue={colorSchema.primaryTextColor}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                          {RegExp.test(colorSchema.primaryTextColor) ===
                            false && <div className="error"></div>}
                          {RegExp.test(colorSchema.primaryTextColor) ===
                            true && <div className="correct"></div>}
                        </div>
                      </div>
                      <div className="col-sm-6">
                        {/* text input */}
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip
                                info={"Color used for details"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Secondary Text Color *&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={"Color used for details"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <input
                            type="text"
                            name="secondaryTextColor"
                            className="form-control inside-form"
                            dir={lan === "rtl" && hold === true ? "rtl" : "ltr"}
                            style={
                              lan === "rtl"
                                ? { textAlign: "end" }
                                : { textAlign: "initial" }
                            }
                            placeholder="Secondary Text Color..."
                            defaultValue={colorSchema.secondaryTextColor}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                          {RegExp.test(colorSchema.secondaryTextColor) ===
                            false && <div className="error"></div>}
                          {RegExp.test(colorSchema.secondaryTextColor) ===
                            true && <div className="correct"></div>}
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip
                                info={"Color used to Highlight heading text"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Primary Highlight Color *&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={"Color used to Highlight heading text"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <input
                            type="text"
                            name="primaryHighlightColor"
                            className="form-control inside-form"
                            dir={lan === "rtl" && hold === true ? "rtl" : "ltr"}
                            style={
                              lan === "rtl"
                                ? { textAlign: "end" }
                                : { textAlign: "initial" }
                            }
                            placeholder="Primary Highlight Color..."
                            defaultValue={colorSchema.primaryHighlightColor}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                          {RegExp.test(colorSchema.primaryHighlightColor) ===
                            false && <div className="error"></div>}
                          {RegExp.test(colorSchema.primaryHighlightColor) ===
                            true && <div className="correct"></div>}
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip
                                info={"Color used to Highlight details text"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Secondary Highlight Color *&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={"Color used to Highlight details text"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <input
                            type="text"
                            name="secondaryHighlightColor"
                            className="form-control inside-form"
                            dir={lan === "rtl" && hold === true ? "rtl" : "ltr"}
                            style={
                              lan === "rtl"
                                ? { textAlign: "end" }
                                : { textAlign: "initial" }
                            }
                            placeholder="Secondary Highlight Color...."
                            defaultValue={colorSchema.secondaryHighlightColor}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                          {RegExp.test(colorSchema.secondaryHighlightColor) ===
                            false && <div className="error"></div>}
                          {RegExp.test(colorSchema.secondaryHighlightColor) ===
                            true && <div className="correct"></div>}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip
                                info={"Background Color used in Element layout"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Element Background Color *&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={"Background Color used in Element layout"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <input
                            type="text"
                            name="elementBackgroundColor"
                            className="form-control inside-form"
                            dir={lan === "rtl" && hold === true ? "rtl" : "ltr"}
                            style={
                              lan === "rtl"
                                ? { textAlign: "end" }
                                : { textAlign: "initial" }
                            }
                            placeholder="Element Background Color..."
                            defaultValue={colorSchema.elementBackgroundColor}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                          {RegExp.test(colorSchema.elementBackgroundColor) ===
                            false && <div className="error"></div>}
                          {RegExp.test(colorSchema.elementBackgroundColor) ===
                            true && <div className="correct"></div>}
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip
                                info={"Color used to Highlight Element text"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Element Foreground Color *&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={"Color used to Highlight Element text"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <input
                            type="text"
                            name="elementForegroundColor"
                            className="form-control inside-form"
                            dir={lan === "rtl" && hold === true ? "rtl" : "ltr"}
                            style={
                              lan === "rtl"
                                ? { textAlign: "end" }
                                : { textAlign: "initial" }
                            }
                            placeholder="Element Foreground Color...."
                            defaultValue={colorSchema.elementForegroundColor}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                          {RegExp.test(colorSchema.elementForegroundColor) ===
                            false && <div className="error"></div>}
                          {RegExp.test(colorSchema.elementForegroundColor) ===
                            true && <div className="correct"></div>}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip
                                info={"Background Color used in Menu layout"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Menu Background Color *&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={"Background Color used in Menu layout"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <input
                            type="text"
                            name="menuBackgroundColor"
                            className="form-control inside-form"
                            dir={lan === "rtl" && hold === true ? "rtl" : "ltr"}
                            style={
                              lan === "rtl"
                                ? { textAlign: "end" }
                                : { textAlign: "initial" }
                            }
                            placeholder="Menu Background Color..."
                            defaultValue={colorSchema.menuBackgroundColor}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                          {RegExp.test(colorSchema.menuBackgroundColor) ===
                            false && <div className="error"></div>}
                          {RegExp.test(colorSchema.menuBackgroundColor) ===
                            true && <div className="correct"></div>}
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip
                                info={"Color used to Highlight Menu"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Menu Foreground Color *&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={"Color used to Highlight Menu"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <input
                            type="text"
                            name="menuForegroundColor"
                            className="form-control inside-form"
                            dir={lan === "rtl" && hold === true ? "rtl" : "ltr"}
                            style={
                              lan === "rtl"
                                ? { textAlign: "end" }
                                : { textAlign: "initial" }
                            }
                            placeholder="Menu Foreground Color..."
                            defaultValue={colorSchema.menuForegroundColor}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                          {RegExp.test(colorSchema.menuForegroundColor) ===
                            false && <div className="error"></div>}
                          {RegExp.test(colorSchema.menuForegroundColor) ===
                            true && <div className="correct"></div>}
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip
                                info={"Background Color used in Button"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Button Background Color *&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={"Background Color used in Button"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <input
                            type="text"
                            name="buttonBackgroundColor"
                            className="form-control inside-form"
                            dir={lan === "rtl" && hold === true ? "rtl" : "ltr"}
                            style={
                              lan === "rtl"
                                ? { textAlign: "end" }
                                : { textAlign: "initial" }
                            }
                            placeholder="Button Background Color..."
                            defaultValue={colorSchema.buttonBackgroundColor}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                          {RegExp.test(colorSchema.buttonBackgroundColor) ===
                            false && <div className="error"></div>}
                          {RegExp.test(colorSchema.buttonBackgroundColor) ===
                            true && <div className="correct"></div>}
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip
                                info={"Color used to Highlight Button text"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Button Foreground Color *&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={"Color used to Highlight Button text"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <input
                            type="text"
                            name="buttonForegroundColor"
                            className="form-control inside-form"
                            dir={lan === "rtl" && hold === true ? "rtl" : "ltr"}
                            style={
                              lan === "rtl"
                                ? { textAlign: "end" }
                                : { textAlign: "initial" }
                            }
                            placeholder="Button Foreground Color..."
                            defaultValue={colorSchema.buttonForegroundColor}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                          {RegExp.test(colorSchema.buttonForegroundColor) ===
                            false && <div className="error"></div>}
                          {RegExp.test(colorSchema.buttonForegroundColor) ===
                            true && <div className="correct"></div>}
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <div
                            className={
                              lan === "rtl"
                                ? "float-right custom-control custom-switch"
                                : "float-left custom-control custom-switch"
                            }
                          >
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              name={"textShadow"}
                              id={"textShadow"}
                              defaultChecked={colorSchema.textShadow}
                              onClick={(event) => updateVisiblity(event)}
                            />
                            <label
                              className="custom-control-label not-bold"
                              htmlFor={"textShadow"}
                              onClick={(e) => e.stopPropagation()}
                            >
                              {lan === "rtl" && (
                                <ToolTip
                                  info={"To give Shadow Effect to the text"}
                                  place={lan === "rtl" ? "left" : "right"}
                                />
                              )}
                              &nbsp;Text Shadow&nbsp;
                              {!(lan === "rtl") && (
                                <ToolTip
                                  info={"To give Shadow Effect to the text"}
                                  place={lan === "rtl" ? "left" : "right"}
                                />
                              )}
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <div
                            className={
                              lan === "rtl"
                                ? "float-right custom-control custom-switch"
                                : "float-left custom-control custom-switch"
                            }
                          >
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              name={"dark"}
                              id={"dark"}
                              defaultChecked={colorSchema.dark}
                              onClick={(event) => updateVisiblity(event)}
                            />
                            <label
                              className="custom-control-label not-bold"
                              htmlFor={"dark"}
                              onClick={(e) => e.stopPropagation()}
                            >
                              {lan === "rtl" && (
                                <ToolTip
                                  info={
                                    "To identify whether Color Schema is dark or light"
                                  }
                                  place={lan === "rtl" ? "left" : "right"}
                                />
                              )}
                              &nbsp;Dark Theme&nbsp;
                              {!(lan === "rtl") && (
                                <ToolTip
                                  info={
                                    "To identify whether Color Schema is dark or light"
                                  }
                                  place={lan === "rtl" ? "left" : "right"}
                                />
                              )}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-12">
                        <div
                          className={
                            lan === "rtl"
                              ? "float-left btn-group btn-group-md"
                              : "float-right btn-group btn-group-md"
                          }
                          role="group"
                        >
                          <button
                            type="submit"
                            className="btn btn-primary"
                            style={{ width: "100px", marginRight: "6px" }}
                            disabled={
                              !colorSchema.primaryBackgroundColor
                                ? true
                                : !colorSchema.secondaryBackgroundColor
                                  ? true
                                  : !colorSchema.primaryTextColor
                                    ? true
                                    : !colorSchema.secondaryTextColor
                                      ? true
                                      : !colorSchema.primaryHighlightColor
                                        ? true
                                        : !colorSchema.secondaryHighlightColor
                                          ? true
                                          : !colorSchema.elementBackgroundColor
                                            ? true
                                            : !colorSchema.elementForegroundColor
                                              ? true
                                              : !colorSchema.menuBackgroundColor
                                                ? true
                                                : RegExp.test(
                                                      colorSchema.elementBackgroundColor
                                                    ) === false
                                                  ? true
                                                  : RegExp.test(
                                                        colorSchema.elementForegroundColor
                                                      ) === false
                                                    ? true
                                                    : RegExp.test(
                                                          colorSchema.menuBackgroundColor
                                                        ) === false
                                                      ? true
                                                      : RegExp.test(
                                                            colorSchema.primaryBackgroundColor
                                                          ) === false
                                                        ? true
                                                        : RegExp.test(
                                                              colorSchema.primaryHighlightColor
                                                            ) === false
                                                          ? true
                                                          : RegExp.test(
                                                                colorSchema.primaryTextColor
                                                              ) === false
                                                            ? true
                                                            : RegExp.test(
                                                                  colorSchema.secondaryBackgroundColor
                                                                ) === false
                                                              ? true
                                                              : RegExp.test(
                                                                    colorSchema.secondaryHighlightColor
                                                                  ) === false
                                                                ? true
                                                                : RegExp.test(
                                                                      colorSchema.secondaryTextColor
                                                                    ) === false
                                                                  ? true
                                                                  : false
                            }
                          >
                            Save
                          </button>

                          {/* {(role.RFP===false&&user.editor === false)&& */}
                          <button
                            type="button"
                            onClick={publishColor}
                            className="btn btn-success"
                            style={{ width: "100px", marginRight: "6px" }}
                            disabled={
                              !colorSchema.primaryBackgroundColor
                                ? true
                                : !colorSchema.secondaryBackgroundColor
                                  ? true
                                  : !colorSchema.primaryTextColor
                                    ? true
                                    : !colorSchema.secondaryTextColor
                                      ? true
                                      : !colorSchema.primaryHighlightColor
                                        ? true
                                        : !colorSchema.secondaryHighlightColor
                                          ? true
                                          : !colorSchema.elementBackgroundColor
                                            ? true
                                            : !colorSchema.elementForegroundColor
                                              ? true
                                              : !colorSchema.menuBackgroundColor
                                                ? true
                                                : RegExp.test(
                                                      colorSchema.elementBackgroundColor
                                                    ) === false
                                                  ? true
                                                  : RegExp.test(
                                                        colorSchema.elementForegroundColor
                                                      ) === false
                                                    ? true
                                                    : RegExp.test(
                                                          colorSchema.menuBackgroundColor
                                                        ) === false
                                                      ? true
                                                      : RegExp.test(
                                                            colorSchema.primaryBackgroundColor
                                                          ) === false
                                                        ? true
                                                        : RegExp.test(
                                                              colorSchema.primaryHighlightColor
                                                            ) === false
                                                          ? true
                                                          : RegExp.test(
                                                                colorSchema.primaryTextColor
                                                              ) === false
                                                            ? true
                                                            : RegExp.test(
                                                                  colorSchema.secondaryBackgroundColor
                                                                ) === false
                                                              ? true
                                                              : RegExp.test(
                                                                    colorSchema.secondaryHighlightColor
                                                                  ) === false
                                                                ? true
                                                                : RegExp.test(
                                                                      colorSchema.secondaryTextColor
                                                                    ) === false
                                                                  ? true
                                                                  : role.production !==
                                                                      true
                                                                    ? true
                                                                    : false
                            }
                            hidden={!role.production === true ? true : false}
                          >
                            Publish
                          </button>
                          {/* // } */}
                          {/* {(role.RFP===true&&user.editor === true)&&
          <button type="button" onClick={publishColor} className="btn btn-success" style={{width:"100px",marginRight:'6px'}}   disabled={!colorSchema.primaryBackgroundColor?true:!colorSchema.secondaryBackgroundColor?true:!colorSchema.primaryTextColor?true:!colorSchema.secondaryTextColor?true:!colorSchema.primaryHighlightColor?true:!colorSchema.secondaryHighlightColor?true:
            !colorSchema.elementBackgroundColor?true:!colorSchema.elementForegroundColor?true:!colorSchema.menuBackgroundColor?true:RegExp.test(colorSchema.elementBackgroundColor)===false?true:RegExp.test(colorSchema.elementForegroundColor)===false?true:RegExp.test(colorSchema.menuBackgroundColor)===false?true:
            RegExp.test(colorSchema.primaryBackgroundColor)===false?true:RegExp.test(colorSchema.primaryHighlightColor)===false?true:RegExp.test(colorSchema.primaryTextColor)===false?true:RegExp.test(colorSchema.secondaryBackgroundColor)===false?true:RegExp.test(colorSchema.secondaryHighlightColor)===false?true:RegExp.test(colorSchema.secondaryTextColor)===false?true:role.production!==true?true:false} hidden={!role.production===true?true:false}>Request to Publish</button>
         } */}
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                {/* /.card-body */}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
};

export default Color;
